import { type ReactNode } from "react";

import { Box, Divider, MenuItem } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface HamburgerMenuItemProps {
  id: string;
  onClick: () => void;
  label: ReactNode;
  attentionCount?: number;
  divider?: boolean;
}

const HamburgerMenuItem = (props: HamburgerMenuItemProps) => {
  const { id, onClick, label, attentionCount, divider } = props;

  return (
    <>
      <MenuItem id={id} onClick={onClick}>
        {label}
        {attentionCount && attentionCount > 0 && (
          <Box
            sx={{
              ml: 0.5,
              color: theme.palette.semantic.primary.main,
              fontWeight: theme.typography.fontWeightMedium
            }}
          >
            ({attentionCount})
          </Box>
        )}
      </MenuItem>
      {divider && <Divider />}
    </>
  );
};

export default HamburgerMenuItem;
